export interface RetryOptions {
    count?: number;
    baseDelayMs?: number;
}

function sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Retries `f` up to `count` times, waiting `baseDelayMs * 2^i` ms between attempts (exponential backoff).
 */
export async function retry<T>(f: () => Promise<T>, options?: RetryOptions): Promise<T> {
    const count = options?.count ?? 5;
    const baseDelayMs = options?.baseDelayMs ?? 500;
    let lastError: unknown;
    for (let i = 0; i < count; i++) {
        try {
            return await f();
        } catch (err) {
            if (i < count - 1) {
                console.error(`Attempt ${i + 1} failed. Retrying...`, err);
                await sleep(baseDelayMs * Math.pow(2, i));
            }
            lastError = err;
        }
    }
    throw lastError;
}
